import { api } from "./client"

export type InterviewType = "video" | "phone" | "onsite"
export type InterviewStatus = "scheduled" | "completed" | "cancelled" | "no_show"

export type Interview = {
  id: string
  application_id: string
  scheduled_at: string
  duration_minutes: number
  type: InterviewType
  location_or_link: string | null
  notes: string | null
  status: InterviewStatus
  created_at: string
  candidate: { id: string; full_name: string; email: string } | null
  job: { id: string; title: string } | null
}

export const interviewsApi = {
  list: (upcoming?: boolean) =>
    api<{ data: Interview[] }>(`/interviews${upcoming ? "?upcoming=true" : ""}`),
  get: (id: string) => api<{ data: Interview }>(`/interviews/${id}`),
  create: (body: {
    application_id: string
    scheduled_at: string
    duration_minutes?: number
    type?: InterviewType
    location_or_link?: string | null
    notes?: string | null
  }) =>
    api<{ ok: boolean; data: Interview }>("/interviews", {
      method: "POST",
      body,
    }),
  update: (
    id: string,
    body: Partial<{
      scheduled_at: string
      duration_minutes: number
      type: InterviewType
      location_or_link: string | null
      notes: string | null
      status: InterviewStatus
    }>,
  ) =>
    api<{ ok: boolean }>(`/interviews/${id}`, {
      method: "PUT",
      body,
    }),
  remove: (id: string) =>
    api<{ ok: boolean }>(`/interviews/${id}`, { method: "DELETE" }),
}
